import Hero from "@/components/home/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Services from "@/components/home/Services";
import FeaturedClass from "@/components/home/FeaturedClass";
import FeaturedFirstFortyDays from "@/components/home/FeaturedFirstFortyDays";
import FeaturedWombLifting from "@/components/home/FeaturedWombLifting";
import CommunityBand from "@/components/home/CommunityBand";
import Manifesto from "@/components/home/Manifesto";
import About from "@/components/home/About";
import Testimonials from "@/components/home/Testimonials";
import ContactSection from "@/components/home/ContactSection";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <EditorialMarquee />
      <FeaturedClass />
      <FeaturedFirstFortyDays />
      <Services />
      <FeaturedWombLifting />
      <CommunityBand />
      <Manifesto />
      <About />
      <Testimonials />
      <ContactSection />
    </main>
  );
}
